module.exports = __webpack_public_path__ + "img/fernanfloo.f84e60dd.png";